import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import {
    CODAM_DESIGN_PORTFOLIO_PATH,
    HOME_DESIGN_SLIDER_ITEMS,
} from '../../constants/homeDesignPortfolio'
import { SLICK_BREAKPOINT_KEY } from '../../constants/slickBreakpoints'

const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    [SLICK_BREAKPOINT_KEY]: [
        { breakpoint: 991, settings: { slidesToShow: 2 } },
        { breakpoint: 767.98, settings: { arrows: false, slidesToShow: 1 } },
    ],
}

const imgBase = `${process.env.PUBLIC_URL || ''}`

const DesignSliderOne = () => {
    return (
        <Fragment>
            <Slider className="row gx-0 blog-active-one" data-aos="fade-up" data-aos-delay={100} {...settings}>
                {HOME_DESIGN_SLIDER_ITEMS.map((val) => {
                    const tagClass = ['tag', val.tagModifier].filter(Boolean).join(' ')
                    return (
                        <div key={`${val.slug}-${val.href}`} className="col-lg-4">
                            <div className="blog-style-one">
                                <div className="blog-thumb">
                                    <img
                                        className="w-100"
                                        src={`${imgBase}${val.imgSrc}`}
                                        alt={val.title}
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <Link to={val.href} className={tagClass}>
                                        {val.tag}
                                    </Link>
                                </div>
                                <div className="blog-content">
                                    <h4>
                                        <Link className="blog-title" to={val.href}>
                                            {val.title}
                                        </Link>
                                    </h4>
                                    <p>{val.desc}</p>
                                    <div className="blog-meta">
                                        <Link to={val.href}>
                                            <i className="bi bi-arrow-up-right" />
                                            상세 보기
                                        </Link>
                                        <Link to={CODAM_DESIGN_PORTFOLIO_PATH}>
                                            <i className="bi bi-grid-3x3-gap" />
                                            전체 포트폴리오
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
        </Fragment>
    )
}

export default DesignSliderOne
